import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 2. 自己项目的重置样式和公用样式
import '@/assets/styles/common.less'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app = createApp(App)

app.use(store).use(router).use(ElementPlus).mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
